import defaults from './integration-center.json'
import type { IntegrationCenterFile, IntegrationRecord } from './IntegrationTypes'
import { LocalJsonStore } from './LocalJsonStore'

const STORAGE_KEY = 'masterhub.integration-center'

export class IntegrationRepository {
  private readonly store = new LocalJsonStore<IntegrationCenterFile>(
    STORAGE_KEY,
    defaults as IntegrationCenterFile,
  )

  getFile(): IntegrationCenterFile {
    return this.store.load()
  }

  saveFile(file: IntegrationCenterFile): boolean {
    return this.store.save({
      ...file,
      updatedAt: new Date().toISOString().slice(0, 10),
    })
  }

  list(): IntegrationRecord[] {
    return [...this.getFile().integrations].sort((a, b) => a.prioridade - b.prioridade)
  }

  findById(id: string): IntegrationRecord | null {
    return this.getFile().integrations.find((item) => item.id === id) ?? null
  }

  upsert(record: IntegrationRecord): IntegrationRecord {
    const file = this.getFile()
    const index = file.integrations.findIndex((item) => item.id === record.id)
    const integrations =
      index >= 0
        ? file.integrations.map((item, i) => (i === index ? record : item))
        : [...file.integrations, record]
    this.saveFile({ ...file, integrations })
    return record
  }

  remove(id: string): boolean {
    const file = this.getFile()
    const next = file.integrations.filter((item) => item.id !== id)
    if (next.length === file.integrations.length) return false
    this.saveFile({ ...file, integrations: next })
    return true
  }

  reset(): IntegrationCenterFile {
    return this.store.reset()
  }
}

export const integrationRepository = new IntegrationRepository()
